<template>
  <on-click-outside @outside="show = false">
    <div @click.stop.prevent="showTooltip" class="tooltip">
      <svg class="db svg-inline--fa fa-exclamation-circle fa-w-16 icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.535 29.535">
        <path fill="currentColor" d="M14.768,0C6.609,0,0,6.609,0,14.768c0,8.155,6.609,14.767,14.768,14.767s14.766-6.612,14.766-14.767 C29.534,6.609,22.927,0,14.768,0z M14.768,27.126c-6.826,0-12.359-5.532-12.359-12.359c0-6.828,5.533-12.362,12.359-12.362 S27.128,7.94,27.128,14.768C27.128,21.594,21.594,27.126,14.768,27.126z"/>
        <polygon fill="currentColor" points="16.338,17.962 16.938,5.601 12.625,5.601 13.227,17.962"/>
        <path fill="currentColor" d="M14.781,19.323c-1.445,0-2.455,1.011-2.455,2.485c0,1.418,0.982,2.482,2.398,2.482h0.057 c1.473,0,2.428-1.064,2.428-2.482C17.182,20.334,16.227,19.323,14.781,19.323z"/>
      </svg>
      <span v-if="show" class="tooltiptext">
        <slot>
          Подсказка
        </slot>
      </span>
    </div>
  </on-click-outside>
</template>

<script>
import OnClickOutside from '@/components/ui/OnClickOutside.vue'

export default {
  components: {
    OnClickOutside
  },
  data: () => ({
    show: false
  }),
  methods: {
    showTooltip () {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  color: #d2dae0;
  &:hover {
    color: #334E68;
  }
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
/* Tooltip text */
.tooltip .tooltiptext {
  position: absolute;
  z-index: 1;
  top: -.35rem;
  right: 150%;
  // width: auto;
  min-width: 15rem;
  max-width: 25rem;
  background-color: white;
  color: #334E68;
  font-size: 0.85rem;
  text-align: left;
  padding: .5rem .5rem .5rem .5rem;
  border-radius: .25rem;
  box-shadow: 0px 0px 0px #d2dae0, 0px 0px 4px #d2dae0;
}
.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  top: 0.85rem;
  left: 100%; /* To the right of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #d2dae0;
}
</style>
